import { createListFilters, IOption } from 'app/components'

export type ModelosFilters = {
  /** Título do modelo (busca parcial). */
  titulo: string
  situacao?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<ModelosFilters>({
  titulo: '',
  situacao: undefined,
})
